export default class UpdateDefaultWorkTypePricingError extends Error {

}
